<template>
  <div>
    <v-container fluid class="px-15 pb-10 pt-4">
      <!-- Encabezado -->
      <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">Empresas (KYC)</div>
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">Aquí puedes consultar el estado de cumplimiento KYC de tus empresas</div>
        </v-col>
        
      </v-row>
      <v-row class="ma-0">
        <v-col class="pa-0 my-4">
          <v-text-field
            v-model="busqueda"
            placeholder="Buscar"
            clearable
            hide-details
            outlined
            style="width: 300px; font-family: 'montserrat-medium'; border-radius: 20px;"
            prepend-inner-icon="mdi-magnify"
          />
        </v-col>
        <v-col class="pa-0 my-4 d-flex justify-end" style="align-items: center;">
          <v-btn color="black" dark rounded @click="openCreateDialog()">
            Crear proceso
          </v-btn>
        </v-col>
      </v-row>

      <!-- Modal Crear Proceso -->
      <v-dialog v-model="dialogCreateProceso" v-if="dialogCreateProceso" max-width="500px" persistent>
        <v-card style="border-radius: 24px;">
          <v-container class="mt-1" style="max-width: 500px">
            <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center;">
              <span class="title font-weight-bold text-textblack">Crear proceso de onboarding</span>
            </v-card-title>
            <v-card-text class="py-6 px-4">
              <v-form ref="procesoForm" autocomplete="off">
                <v-autocomplete
                  v-model="nuevoProceso.empresa_id"
                  :items="empresasDisponibles"
                  :loading="isLoadingEmpresas"
                  item-text="sName"
                  item-value="sCustomerEnterpriseId"
                  label="Empresa *"
                  outlined
                  clearable
                  :rules="[rules.required]"
                  no-data-text="No hay empresas disponibles"
                  class="mb-4"
                />
                <v-select
                  v-model="nuevoProceso.producto"
                  :items="productosDisponibles"
                  item-text="text"
                  item-value="value"
                  label="Producto *"
                  outlined
                  :rules="[rules.required]"
                />
              </v-form>
            </v-card-text>
            <v-card-actions class="mt-2" style="justify-content: space-evenly">
              <v-btn outlined rounded :disabled="isCreatingProceso" @click="closeCreateDialog()">Cancelar</v-btn>
              <v-btn color="black" dark rounded :disabled="isCreatingProceso || !isProcesoFormValid" :loading="isCreatingProceso" @click="createProceso()">Crear</v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Tabla de empresas -->
      <v-data-table :items="filteredItems" class="d-none d-sm-block" hide-default-header>
        <template v-slot:header>
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">Empresa</th>
              <th class="header__title center">Producto</th>
              <th class="header__title center">Estatus Onboarding</th>
              <th class="header__title center">Requeridos</th>
              <th class="header__title center">Aprobados</th>
              <th class="header__title center">Pendientes</th>
              <th class="header__title center">Rechazados</th>
              <th class="header__title center">% Cumplimiento</th>
              <th class="header__title right">Acciones</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.empresa_id">
              <td class="table__item">{{ item.empresaNombre }}</td>
              <td class="table__item">{{ item.producto }}</td>
              <td class="table__item">{{ item.estatusOnboarding }}</td>
              <td class="table__item">{{ item.totalDocumentos }}</td>
              <td class="table__item">{{ item.aprobados }}</td>
              <td class="table__item">{{ item.pendientes }}</td>
              <td class="table__item">{{ item.rechazados }}</td>
              <td class="table__item">{{ item.porcentajeCumplimiento }}%</td>
              <td class="table__item">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="goToDetail(item)" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver detalles</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      empresas: [],
      busqueda: '',
      dialogCreateProceso: false,
      isLoadingEmpresas: false,
      isCreatingProceso: false,
      empresasDisponibles: [],
      procesosExistentes: [],
      todosLosProductos: [
        { text: 'Divisas', value: 'divisas' },
        { text: 'Factoraje Cedente', value: 'factoraje_cedente' },
        { text: 'Factoraje Deudor', value: 'factoraje_deudor' },
        { text: 'Crédito Revolvente', value: 'credito_revolvente' },
      ],
      nuevoProceso: {
        empresa_id: null,
        producto: null,
      },
      rules: {
        required: (v) => !!v || 'Este campo es requerido',
      },
    };
  },
  watch: {
    'nuevoProceso.empresa_id'() {
      this.nuevoProceso.producto = null;
    },
  },
  computed: {
    isProcesoFormValid() {
      return !!this.nuevoProceso.empresa_id && !!this.nuevoProceso.producto;
    },
    productosDisponibles() {
      if (!this.nuevoProceso.empresa_id) return this.todosLosProductos;
      const productosUsados = this.procesosExistentes
        .filter((p) => p.empresa_id === this.nuevoProceso.empresa_id)
        .map((p) => p.producto);
      return this.todosLosProductos.filter((p) => !productosUsados.includes(p.value));
    },
    filteredItems() {
        if (!this.busqueda) return this.empresas;

        const filtro = this.busqueda.toLowerCase();

        return this.empresas.filter((item) => {
          const empresaNombre = item.empresaNombre?.toLowerCase() || '-';
          const statusOnboarding = item.estatusOnboarding?.toLowerCase() || '-';
          const producto = item.producto?.toLowerCase() || '-';

          return (
            empresaNombre.includes(filtro) ||
            statusOnboarding.includes(filtro) ||
            producto.includes(filtro)
          );
        });
      }
  },
  methods: {
    getEmpresas() {
      this.loading = true;
      this.alerts = [];

      DB.get(`${URI}/api/v1/en/administrator/onboarding/empresas`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.empresas = response.data.empresas;
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.loading = false;
      });
    },
    goToDetail(item) {
      this.$router.push({ name: 'KycDetail', params: { empresaId: item.empresaId, producto: item.product_type || item.producto } });
    },
    openCreateDialog() {
      this.dialogCreateProceso = true;
      this.getEmpresasDisponibles();
    },
    closeCreateDialog() {
      this.dialogCreateProceso = false;
      this.nuevoProceso = { empresa_id: null, producto: null };
      if (this.$refs.procesoForm) {
        this.$refs.procesoForm.resetValidation();
      }
    },
    getEmpresasDisponibles() {
      this.isLoadingEmpresas = true;
      DB.get(`${URI}/api/v1/en/administrator/onboarding/empresas-disponibles`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.empresasDisponibles = response.data.empresas;
        this.procesosExistentes = response.data.procesosExistentes;
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.isLoadingEmpresas = false;
      });
    },
    createProceso() {
      if (!this.$refs.procesoForm.validate()) return;

      this.isCreatingProceso = true;
      DB.post(`${URI}/api/v1/en/administrator/onboarding/empresa`, {
        empresa_id: this.nuevoProceso.empresa_id,
        producto: this.nuevoProceso.producto,
      }, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.mixSuccess(response.data.message);
        this.closeCreateDialog();
        this.getEmpresas();
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.isCreatingProceso = false;
      });
    },
  },
  mounted() {
    this.getEmpresas();
  }
};
</script>

<style scoped>
</style>
